// Convert from degrees to radians
const degreesToRadians = (degrees) => {
    var radians = (degrees * Math.PI) / 180;
    return radians;
};

export const calcDistance = (startingCoords, destinationCoords) => {
    let startingLat = degreesToRadians(startingCoords.lat);
    let startingLong = degreesToRadians(startingCoords.lng);
    let destinationLat = degreesToRadians(destinationCoords.lat);
    let destinationLong = degreesToRadians(destinationCoords.lng);

    // Radius of the Earth in kilometers
    let radius = 6571;

    // Haversine equation
    const distanceInKilometers = Math.acos(Math.sin(startingLat) * Math.sin(destinationLat) +
        Math.cos(startingLat) * Math.cos(destinationLat) *
        Math.cos(startingLong - destinationLong)) * radius;

    return distanceInKilometers;
};

export const sortDistances = (a, b) => {
    if (a.distance < b.distance) {
        return -1;
    }
    if (a.distance > b.distance) {
        return 1;
    }
    return 0;
};
